'use client';

import { useCallback, useEffect, useState } from 'react';
import {
    RecentSearch,
    addRecentSearch,
    clearRecentSearches,
    readRecentSearches,
    toRecentSearch
} from '@/hotdesk-ui/helpers/recent-searches';
import { GeoCodeResult } from '@/hotdesk-ui/types/geo-code-result.type';

/**
 * Recent searches backed by localStorage. The initial state stays empty and is
 * filled in an effect so the server and first client render agree — reading
 * storage during render would tear the tree down on hydration.
 */
export function useRecentSearches() {
    const [recent, setRecent] = useState<RecentSearch[]>([]);

    useEffect(() => {
        setRecent(readRecentSearches());
    }, []);

    const record = useCallback((result: GeoCodeResult) => {
        const entry = toRecentSearch(result);
        if (!entry) return;
        setRecent(addRecentSearch(entry));
    }, []);

    const clear = useCallback(() => {
        clearRecentSearches();
        setRecent([]);
    }, []);

    return { recent, record, clear };
}

export default useRecentSearches;
